<template>
  <div style="width: 100%;">
    <label :for="editorId" class="v-label pt-4">
      {{ label }}
    </label>
    <quill-editor
        @if="projectId !== undefined && userId !== undefined && folder !== undefined"
        :id="editorId"
        ref="quillEditor"
        :value="content"
        :options="editorOptions"
        class="pt-1 mb-4 quill-editor"
        @ready="onEditorReady"
        @input="onEditorInput"
    ></quill-editor>
  </div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor';
import config from "../../../main/config";
import axios from 'axios';
import sendRequest from "../../../main/helpers/requestHelper";

export default {
  name: 'CustomQuillEditor',
  components: {
    quillEditor,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    folder: {
      type: String,
    },
    userId: {
      type: [String, Number],
    },
    projectId: {
      type: [String, Number],
    },
  },
  data() {
    return {
      content: this.value,
      editorId: `quill-editor-${this._uid}`,
      editorOptions: {
        theme: 'snow',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline'],
            [{list: 'ordered'}, {list: 'bullet'}],
            ['image'],
          ],
          imageUploader: {
            upload: file => {
              const formData = new FormData();
              formData.append('image', file);
              formData.append('userId', this.userId);
              formData.append('projectId', this.projectId);
              formData.append('folder', this.folder);

              return sendRequest(
                  "post",
                  config.baseURLApi + "/projects/upload-image",
                  {
                    'Content-Type': 'multipart/form-data',
                  },
                  formData
              ).then(function(result) {
                console.log(result[0] === "success");
                if(result[0] === "success") {
                  let apiUrl = config.baseURLApi.slice(0, -4);
                  let imageUrl = result[1].data.url;
                  console.log(apiUrl);
                  console.log(imageUrl);
                  console.log(apiUrl + '' + result[1].data.url);
                  return apiUrl + '' + result[1].data.url;
                } else {
                  return Promise.reject('Upload failed');
                }
              });
            },
          },
        },
      },
    };
  },
  watch: {
    value(newVal) {
      if (newVal !== this.content) {
        this.content = newVal;
        this.updateEditorContent(newVal);
      }
    },
  },
  methods: {
    onEditorReady() {
      this.updateEditorContent(this.content);
    },
    onEditorInput(newContent) {
      this.content = newContent;
      this.$emit('input', newContent);
    },
    updateEditorContent(content) {
      if (this.$refs.quillEditor && this.$refs.quillEditor.quill) {
        const editor = this.$refs.quillEditor.quill;
        const delta = editor.clipboard.convert(content || '');
        editor.setContents(delta);
      }
    },
  },
};
</script>

<style scoped>
.v-label {
  display: block;
  margin-bottom: 8px;
  color: rgba(0, 0, 0, 0.6);
  font-size: 14px;
}

.quill-editor .ql-container {
  min-height: 300px !important;
}
</style>
